import { Box, CircularProgress } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import LoadingDots from './LoadingDots';

export const LoadingComponent = ({ errorMsg, styles, fontStyles = { color: "gray" } }) => {
    const backColor = "whitesmoke";
    document.body.style.backgroundColor = backColor;

    return (
        <Box
            className="RegularMadeTommy text-center"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                padding: "0rem 5rem",
            }}
        >
            {errorMsg ?
                <h2 style={fontStyles}>
                    {errorMsg}
                </h2>
                :
                <>
                    {/* <span className="loader"></span> */}
                    <svg width={0} height={0}>
                        <defs>
                            <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                                <stop offset="0%" stopColor="#868688" />
                                <stop offset="100%" stopColor="#d4d8d0" />
                            </linearGradient>
                        </defs>
                    </svg>
                    <CircularProgress
                        sx={{
                            'svg circle': { stroke: 'url(#my_gradient)', strokeLinecap: 'round' },
                            width: "80px !important", // Increase the size
                            height: "80px !important",
                        }}
                    />
                    <LoadingDots
                        text={
                            <FormattedMessage
                                id="loading.msg"
                                defaultMessage={'Cargando'}
                            />
                        }
                        dotCount={0}
                        color="gray"
                        styles={{ fontSize: "1.7rem", marginTop: "0.5rem" }}
                    />
                </>
            }
        </Box>
    )
}
